import { Link } from 'react-router-dom';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import SafeImage from '../../components/SafeImage';
import { coerceLocalDate } from '../my-journeys/myJourneysModel';

function formatJourneyDate(value) {
  const iso = coerceLocalDate(value);
  if (!iso) return '';
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(date);
}

export default function CreatorJourneyCard({ journey }) {
  const { t, tf } = useTravelTranslation();
  const range = [formatJourneyDate(journey.startDate), formatJourneyDate(journey.endDate)].filter(Boolean).join(' – ');
  const coverAlt = journey.title ? tf('travel.creator.coverAlt', { title: journey.title }) : '';
  return <article className="creator-journey-card">
    <Link to={`/public/journeys/${journey.publicationId}`}>
      <SafeImage src={journey.coverUrl} alt={coverAlt} fallback={<span className="creator-journey-card__fallback" aria-hidden="true">✦</span>} />
      <div>
        <small>{t('travel.creator.publicItinerary')}</small>
        <h2>{journey.title}</h2>
        {journey.summary ? <p>{journey.summary}</p> : null}
        {journey.destination ? <strong>{journey.destination}</strong> : null}
        {range ? <time>{range}</time> : null}
        <span>{tf('travel.creator.dayActivityCount', { days: journey.dayCount, activities: journey.activityCount })}</span>
      </div>
    </Link>
  </article>;
}
